<p>
  protected works!
</p>
